import { Map } from 'immutable';
// immutable has many good use cases. Read more at: https://immutable-js.github.io/immutable-js/
import { POPULATE_ROLES } from '@constants/actions';

const initialState = Map({
  roleList: [],
  totalCount: 0,
});

const Roles = (state = initialState, action: any) => {
  const actionPayload = action.payload;
  switch(action.type) {
    case POPULATE_ROLES:
      return state.set('roleList', actionPayload.roles).
        set('totalCount', actionPayload.totalCount);
    default:
      return state;
  }
};

export default Roles;